import {useParams} from 'react-router-dom';

import {orderColumns, useGetUserOrders} from '@entities/order';
import {MrTable} from '@shared/components';
import {entityTableCommonProps} from '@shared/constants';
import {useUrlState} from '@shared/hooks';

import {PaginationState} from '@/shared/types';

// Bumped: the column set and their order have changed
const localStorageKey = 'userAccountOrderTableV6';

type UrlState = PaginationState;

export const OrdersTab = () => {
  const {id: userId} = useParams<{id: string}>();

  const {urlState, setUrl} = useUrlState<UrlState>({
    pageIndex: 0,
    pageSize: 10,
  });

  const {
    data,
    isPending: isLoading,
    error,
  } = useGetUserOrders(
    {
      userId: userId ?? '',
      page: urlState.pageIndex + 1,
      pageSize: urlState.pageSize,
    },
    {enabled: !!userId},
  );

  return (
    <MrTable
      columns={orderColumns}
      data={data?.items ?? []}
      error={error}
      enableColumnOrdering
      enableColumnDragging={false}
      localStorageKeyForSettings={localStorageKey}
      enableHiding
      /////////////////////////////
      // pagination + state
      enablePagination
      manualPagination
      onPaginationChange={setUrl}
      rowCount={data?.total ?? 0}
      /////////////////////////////
      state={{
        isLoading,
        pagination: urlState,
      }}
      enableColumnPinning
      initialState={{
        columnPinning: {
          left: ['id'],
        },
      }}
      {...entityTableCommonProps}
      enableRowActions={false}
    />
  );
};
